"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const car_details_widget_styles_1 = require("./car-details-widget.styles");
const building_blocks_ui_acko_analytics_1 = require("@acko-tech/building-blocks.ui.acko-analytics");
const btn_loader_1 = __importDefault(require("./btn-loader"));
const NewCarLink_1 = __importDefault(require("./NewCarLink"));
// export const carNumberRegex =
//   '^(AN|AP|AR|AS|BR|CG|CH|DN|DD|DL|GA|GJ|HR|HP|JK|JS|JH|KA|KL|LD|MP|MH|MN|ML|MZ|NL|OR|OD|PB|PY|PN|RJ|SK|TG|TN|TS|TR|UA|UK|UP|WB)( *)( *|-)( *)([0-9]{1,2})( *)( *|-)( *)((([a-zA-Z]{1,3})( *)( *|-)( *)([0-9]{1,4}))|([0-9]{4}))$';
// export const carNumberBHRegex = /^[2-3][0-9][B][H](([1-9]\d\d\d)|(\d[1-9]\d\d)|(\d\d\[1-9]\d)|(\d\d\d[1-9]))[A-HJ-NP-Z]{1,2}$/
function CarDetailsWidget({ isDesktop, onSubmit, ctaLabel, regNumberInput, mobileNumberInput, isFetching, onFocus, hideMobileNumberField, requestUrl, hideNewCarFlow, newCarRedirectionLink, okind, InsureSegmentTrackProps, regexPatterns }) {
    const [fieldState, setFieldState] = (0, react_1.useState)({
        carNumber: '',
        mobileNumber: '',
    });
    const [errorsState, setErrorsState] = (0, react_1.useState)({});
    const termsAndCond = 'T & C apply*';
    const onBlurCarInput = () => __awaiter(this, void 0, void 0, function* () {
        const isValid = handleValidation(true, false, regexPatterns);
        if (typeof (regNumberInput === null || regNumberInput === void 0 ? void 0 : regNumberInput.onBlur) !== 'function')
            return;
        if (!isValid) {
            try {
                yield (0, building_blocks_ui_acko_analytics_1.trackEvent)('tap_btn_entered_invalid_car_number', Object.assign(Object.assign({}, InsureSegmentTrackProps), { widget_type: 'sticky widget', registration_number: fieldState === null || fieldState === void 0 ? void 0 : fieldState.carNumber, error_message: errorsState['carNumber'] || "Enter valid car registration number" }));
            }
            catch (error) {
                console.log('Error on [tap_btn_entered_invalid_car_number]', error === null || error === void 0 ? void 0 : error.message);
            }
        }
        regNumberInput === null || regNumberInput === void 0 ? void 0 : regNumberInput.onBlur(isValid, fieldState === null || fieldState === void 0 ? void 0 : fieldState.carNumber, fieldState === null || fieldState === void 0 ? void 0 : fieldState.mobileNumber); // send state
    });
    const onBlurMobileInput = () => __awaiter(this, void 0, void 0, function* () {
        const isValid = handleValidation(false, true, regexPatterns);
        if (typeof (mobileNumberInput === null || mobileNumberInput === void 0 ? void 0 : mobileNumberInput.onBlur) !== 'function')
            return;
        if (!isValid) {
            try {
                yield (0, building_blocks_ui_acko_analytics_1.trackEvent)('tap_btn_entered_invalid_mobile_number', Object.assign(Object.assign({}, InsureSegmentTrackProps), { widget_type: 'sticky widget', registration_number: fieldState === null || fieldState === void 0 ? void 0 : fieldState.carNumber, error_message: errorsState['mobileNumber'] || "Enter valid Mobile number" }));
            }
            catch (error) {
                console.log('Error on [tap_btn_entered_invalid_mobile_number]', error === null || error === void 0 ? void 0 : error.message);
            }
        }
        mobileNumberInput === null || mobileNumberInput === void 0 ? void 0 : mobileNumberInput.onBlur(isValid, fieldState === null || fieldState === void 0 ? void 0 : fieldState.carNumber, fieldState === null || fieldState === void 0 ? void 0 : fieldState.mobileNumber); //send data
    });
    const handleValidation = (validateCarNumber, validatePhone, regexPatterns) => {
        const { carNumber, mobileNumber } = fieldState;
        let errors = {};
        let formIsValid = true;
        if (validateCarNumber) {
            //Car Number
            if (!carNumber) {
                formIsValid = false;
                errors['carNumber'] = 'Enter your car number e.g MH02L9876';
            }
            else {
                const formattedRegNo = carNumber.toUpperCase().replace(/[. ,:-]+/g, "");
                const isValid = regexPatterns.some((pattern) => new RegExp(pattern, "i").test(formattedRegNo));
                if (!isValid) {
                    formIsValid = false;
                    errors['carNumber'] = 'You typed an invalid car number!';
                }
            }
        }
        if (!hideMobileNumberField && validatePhone) {
            //mobile number
            if (!mobileNumber) {
                formIsValid = false;
                errors['mobileNumber'] = 'Enter your 10 digit mobile number';
            }
            else if (!/^[6-9]\d{9}$/i.test(mobileNumber)) {
                formIsValid = false;
                errors['mobileNumber'] = 'You typed an invalid mobile number!';
            }
        }
        setErrorsState(errors);
        return formIsValid;
    };
    const handleRegNumberChange = (e) => {
        const value = e.target.value;
        setFieldState(Object.assign(Object.assign({}, fieldState), { carNumber: value }));
        regNumberInput === null || regNumberInput === void 0 ? void 0 : regNumberInput.onChange(e, fieldState === null || fieldState === void 0 ? void 0 : fieldState.carNumber, fieldState === null || fieldState === void 0 ? void 0 : fieldState.mobileNumber); // send event and maintain state here only
    };
    const handleMobileNumberChange = (e) => {
        const value = e.target.value;
        setFieldState(Object.assign(Object.assign({}, fieldState), { mobileNumber: value }));
        mobileNumberInput === null || mobileNumberInput === void 0 ? void 0 : mobileNumberInput.onChange(e, fieldState === null || fieldState === void 0 ? void 0 : fieldState.carNumber, fieldState === null || fieldState === void 0 ? void 0 : fieldState.mobileNumber); // send event and maintain state here only
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        const isValid = handleValidation(true, true, regexPatterns);
        onSubmit(isValid, fieldState === null || fieldState === void 0 ? void 0 : fieldState.carNumber, fieldState === null || fieldState === void 0 ? void 0 : fieldState.mobileNumber); // send values of input fields
    };
    const handleTerms = () => {
        if (typeof window !== 'undefined') {
            window.open(`/terms-and-conditions/`, '_blank');
        }
    };
    return (react_1.default.createElement("form", { name: "car-details-widget" },
        react_1.default.createElement(car_details_widget_styles_1.CarInputContainer, { isDesktop: isDesktop },
            react_1.default.createElement(car_details_widget_styles_1.CarNumberInput, { type: "text", placeholder: (regNumberInput === null || regNumberInput === void 0 ? void 0 : regNumberInput.placeholder) || 'Enter your car number e.g MH02L9876', onChange: handleRegNumberChange, value: fieldState === null || fieldState === void 0 ? void 0 : fieldState.carNumber, shouldAutoCapitalize: true, onBlur: onBlurCarInput, onFocus: onFocus }),
            react_1.default.createElement(car_details_widget_styles_1.ErrorMessage, { isDesktop: isDesktop }, errorsState['carNumber'])),
        !hideMobileNumberField ? (react_1.default.createElement(car_details_widget_styles_1.MobileNumberInputContainer, { isDesktop: isDesktop },
            react_1.default.createElement(car_details_widget_styles_1.MobileNumberInput, { type: "number", placeholder: (mobileNumberInput === null || mobileNumberInput === void 0 ? void 0 : mobileNumberInput.placeholder) || 'Mobile Number', onChange: handleMobileNumberChange, value: fieldState === null || fieldState === void 0 ? void 0 : fieldState.mobileNumber, onBlur: onBlurMobileInput, onFocus: onFocus }),
            react_1.default.createElement(car_details_widget_styles_1.ErrorMessage, { isDesktop: isDesktop }, errorsState['mobileNumber']))) : null,
        react_1.default.createElement(car_details_widget_styles_1.StyledButton, { onClick: handleSubmit, isDesktop: isDesktop }, isFetching ? (react_1.default.createElement(btn_loader_1.default, { styles: isDesktop ? car_details_widget_styles_1.ButtonLoaderDesktop : car_details_widget_styles_1.ButtonLoaderMobile })) : (ctaLabel || 'Insure Now')),
        react_1.default.createElement(car_details_widget_styles_1.TermsButton, { isDesktop: isDesktop, onClick: handleTerms }, termsAndCond),
        !hideNewCarFlow ? (react_1.default.createElement(NewCarLink_1.default, { requestUrl: requestUrl, newCarRedirectionLink: newCarRedirectionLink, okind: okind, InsureSegmentTrackProps: InsureSegmentTrackProps })) : null));
}
// trigger version bump
exports.default = CarDetailsWidget;
//# sourceMappingURL=car-details-widget.js.map